import { decodeGeohash } from '../utils/geo';

var REGION_CODES = null;

angular.module('app.directives').directive('analyticsGeoChart', function () {
  'ngInject';

  return {
    restrict: 'E',
    scope: {
      analytics: '=',
    },
    link: function (scope, element, attrs, ngModelCtrl) {},
    controller: AnalyticsGeoController,
    controllerAs: 'vm',
    template: `
        <style>
        .leaflet-container {
            width: 100%;
            height: calc(33vw);
            max-height: 300px;
            min-height: 100px;
        }
        </style>
        <link rel="stylesheet" href="//cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/leaflet.css" />
        <div ng-if="!vm.geoPoints">
          <i class="fa fa-spin fa-spinner"></i> Loading...
        </div>
        <div ng-if="vm.geoPoints && !vm.geoPoints.length">
          <p style="margin-top:15px;opacity:0.8;text-align:center;">
            No geographic data is available.
          </p>
        </div>
        <div ng-if="vm.geoPoints && vm.geoPoints.length">
          <leaflet defaults="{scrollWheelZoom: false, maxZoom: 8}"
                    bounds="vm.bounds"
                    paths="vm.paths"
                    ng-if="vm.bounds"></leaflet>
        </div>
      `,
  };
});

class AnalyticsGeoController {
  constructor($scope, $http) {
    'ngInject';

    this.$scope = $scope;
    this.$http = $http;

    if (REGION_CODES) {
      this.regionDict = REGION_CODES;
    } else {
      $http.get('/img/region_codes.json').then((response) => {
        REGION_CODES = this.regionDict = response.data;
        this.analytics && this.computeGeo();
      });
    }

    require.ensure(['leaflet'], () => {
      window.leaflet = window.L = require('leaflet');

      $scope.$evalAsync(() => {
        this.analytics = $scope.analytics;
        this.analytics && this.computeGeo();
      });

      $scope.$watch('analytics', (analytics) => {
        this.analytics = analytics;
        if (analytics) {
          this.computeGeo();
        }
      });
    });
  }

  computeGeo() {
    this.geoPoints = [];
    var maxCount = 0,
      minCount = 0;

    _.each(this.analytics.view_counts_by_geohash, (count, geohash) => {
      if (!geohash) return;
      var pos = decodeGeohash(geohash);
      this.geoPoints.push({
        latitude: pos.latitude[0],
        longitude: pos.longitude[0],
        count: count,
      });
      if (!count || count > maxCount) maxCount = count;
      if (!count || count < minCount) minCount = count;
    });

    this.geoPoints.forEach((p) => {
      // compute radius ... linear distribution between 1,000 and 100,000
      // TODO: the min/max bounds should probably account for the average distance
      // between points (e.g. if on 2 sides of globe, make each cluster larger
      // than if just in 3-4 different counties in same state)
      var count = p.count,
        radius = 0;
      if (count == minCount) {
        radius = 1000;
      } else if (count == maxCount) {
        radius = 100000;
      } else {
        radius = ((100000 - 1000) / (maxCount - minCount)) * count;
      }
      p.geoRadius = Math.round(radius);
    });

    this.geoPoints = _.sortBy(this.geoPoints, 'count');
    this.geoPoints.reverse();

    this.fitMap();
  }

  fitMap() {
    const { geoPoints } = this;

    if (!geoPoints) return;

    this.bounds = {
      northEast: {
        lat: _.min(_.pluck(this.geoPoints, 'latitude')),
        lng: _.min(_.pluck(this.geoPoints, 'longitude')),
      },
      southWest: {
        lat: _.max(_.pluck(this.geoPoints, 'latitude')),
        lng: _.max(_.pluck(this.geoPoints, 'longitude')),
      },
    };

    this.paths = {};
    var i = 0;
    this.geoPoints.forEach((p) => {
      this.paths[`path${i++}`] = {
        type: 'circle',
        color: '#5DA5DA',
        weight: '2',
        radius: parseInt(p.geoRadius, 10),
        latlngs: {
          lat: p.latitude,
          lng: p.longitude,
        },
      };
    });
  }
}



// WEBPACK FOOTER //
// ./app/directives/analytics-geo-chart.js